import React, { useContext, useEffect, useState } from 'react';
import './services-detail.scss';
import { useParams } from "react-router-dom";
import { AppContext } from '../../services/translationContext';
import { Link } from "react-router-dom";
import { VectorAnimated } from '../../components/vector-animated/vector-animated';
import DOMPurify from 'dompurify';
import { Loader } from '../../components/loader/loader';

const api = process.env.REACT_APP_URL_API;

export const ServicesDetail = () => {
    const text_test1 = `
    <p>At Sydea, we specialize in providing cutting-edge IT solutions to drive your business forward. Our expertise in Microsoft Dynamics 365 Business Central offers you a comprehensive, cloud-based ERP solution tailored to your specific needs. Whether you're a small startup or a large enterprise, our Dynamic Business Central services are designed to optimize your business operations, enhance productivity, and support growth.</p><h2 style='color:#fece2f;'>What is Microsoft Dynamics 365 Business Central?</h2><p>Microsoft Dynamics 365 Business Central is an all-in-one business management solution that enables organizations to streamline processes, make smarter decisions, and accelerate growth. As a robust cloud-based ERP system, Business Central integrates finance, sales, service, and operations into a single application, ensuring your business functions as a cohesive unit.</p><h2 style='color:#fece2f;'>Our Dynamic Business Central Services</h2><ul style='list-style:decimal'><li><h3 style='color:#fece2f;'>Implementation & Customization</h3><p>Sydea understands that every business is unique. Our team of certified experts will work closely with you to understand your specific needs and goals. We offer tailored implementation services to ensure a seamless integration of Business Central into your existing IT infrastructure. From initial setup to advanced customization, we provide solutions that align with your business processes.</p></li><li><h3 style='color:#fece2f;'>Migration Services</h3><p>Transitioning to Business Central from legacy systems can be complex. Sydea offers comprehensive migration services to make this transition smooth and efficient. We handle data migration, system integration, and user training, ensuring minimal disruption to your daily operations.</p></li><li><h3 style='color:#fece2f;'>System Integration</h3><p>Our integration services enable Business Central to work harmoniously with other applications and platforms your business relies on. We ensure seamless data flow and integration with systems such as CRM, e-commerce platforms, and third-party applications, enhancing overall operational efficiency.</p></li><li><h3 style='color:#fece2f;'>Support & Maintenance</h3><p>At Sydea, we believe in building lasting relationships with our clients. Our support and maintenance services provide you with continuous assistance post-implementation. From troubleshooting and updates to performance optimization, our team is here to support your Business Central system around the clock.</p></li><li><h3 style='color:#fece2f;'>Training & Consultancy</h3><p>To maximize the potential of Business Central, we offer comprehensive training programs tailored to your team’s needs. Our experts provide hands-on training, ensuring your staff is well-equipped to utilize all features of Business Central effectively. Additionally, our consultancy services help you identify and implement best practices for optimal results.</p></li></ul><h2 style='color:#fece2f;'>Why Choose Sydea for Your Business Central Needs?</h2><ul><li><h3 style='color:#fece2f;'>Expertise</h3><p>With years of experience in implementing and managing Microsoft Dynamics 365 Business Central, our team has the skills and knowledge to deliver outstanding results.</p></li><li><h3 style='color:#fece2f;'>Customization</h3><p>We don't believe in one-size-fits-all solutions. Our services are tailored to fit the specific needs of your business, ensuring you get the most out of your Business Central investment.</p></li><li><h3 style='color:#fece2f;'>Support</h3><p>Our commitment to your success doesn't end with implementation. We provide ongoing support to ensure your Business Central solution continues to deliver value over time..</p></li><li><h3 style='color:#fece2f;'>Innovation</h3><p>We stay ahead of industry trends and incorporate the latest technologies into our solutions, keeping your business competitive in a rapidly evolving market.</p></li></ul><p>Transform your business operations with the power of Microsoft Dynamics 365 Business Central. Contact Sydea today to learn how our Dynamic Business Central services can help you achieve greater efficiency, improve decision-making, and drive growth.</p>
    `;

    let { area_id } = useParams();
    let { service_id } = useParams();
    let { sub_area } = useParams();

    const { services: {TranslationsService} } = useContext(AppContext);
    // document.title = `${service_id ? TranslationsService.labels(`services.${area_id}.${service_id}.title`) : TranslationsService.labels(`services.${area_id}.title`)} | ${TranslationsService.getMainInfoCompany('name')}`;
    const [showLoader, setShowLoader] = useState(false);
    const [listClientStories, setListClientStories] = useState([]);

    const determineTitleAndAnimation = () => {
      let title;
      let animationName;
  
      if (service_id && sub_area) {
        title = TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.title`);
        animationName = TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.animation`);
      } else if (service_id) {
        title = TranslationsService.labels(`services.${area_id}.${service_id}.title`);
        animationName = TranslationsService.labels(`services.${area_id}.${service_id}.animation`);
      } else {
        title = TranslationsService.labels(`services.${area_id}.title`);
        animationName = area_id;
      }
      return { title, animationName };
    };
  
    const { title, animationName } = determineTitleAndAnimation();
  
    useEffect(() => {
      document.title = `${title} | ${TranslationsService.getMainInfoCompany('name')}`;
    }, [title]);

    const openMailForContact = () => {
      if(sub_area){
        const recipient = TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.contact-mail`);
        const subject = `[${TranslationsService.labels(`services.${area_id}.title`)}-${TranslationsService.labels('services')[area_id].items[sub_area].title}-${TranslationsService.labels('services')[area_id].items[sub_area][service_id].title}] ${TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.subject-mail`)}`
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}`;
        window.location.href = mailtoLink;
      }
      else {
        const recipient = TranslationsService.labels(`services.${area_id}.${service_id}.contact-mail`);
        const subject = `[${TranslationsService.labels(`services.${area_id}.title`)}-${TranslationsService.labels(`services.${area_id}.${service_id}.title`)}] ${TranslationsService.labels(`services.${area_id}.${service_id}.subject-mail`)}`
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}`;
        window.location.href = mailtoLink;
      }
    }

    useEffect(() => {
      setListClientStories([]);
      if(!service_id || !TranslationsService.childMenuAvailable('insightsSections.client-stories')){
        return;
      }
      setShowLoader(true);
      fetch(`${api}/content-public?id=client-stories&language=${TranslationsService.getCurrentLanguage()}&service=${area_id},${service_id}`)
      .then(response => response.json()).then(data => {
        setListClientStories(data.data);
        setShowLoader(false);
      });
    },[area_id, service_id, TranslationsService]);
    
  return (
    <div className="section-home">
      {
        showLoader &&
        <Loader />
      }
      {
        service_id ?
        (
          <header className='p-3 header-services-detail position-relative d-flex align-items-center'>
            <VectorAnimated animationName={animationName} />
            <div className='p-2 w-75'>
              {
                sub_area ?
                (
                  <>
                    <p className='dark-mode-text m-0 breadcrumb-detail'>
                      <Link to='/' className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
                      &nbsp;&#9656;&nbsp;
                      <Link to='/services' className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.services.label`)}</Link>
                      &nbsp;&#9656;&nbsp;
                      <Link to={`/services/${area_id}`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`services.${area_id}.title`)} - {TranslationsService.labels('services')[area_id].items[sub_area].title}</Link>
                      {/* &nbsp;&#9656;&nbsp;
                      <Link to={`/services/${area_id}/${sub_area}`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels('services')[area_id].items[sub_area].title}</Link> */}
                    </p>
                    <h2 className='syd-title light fw-bold'>{TranslationsService.labels('services')[area_id].items[sub_area][service_id].title}</h2>
                    <p className='pre-line-w-space dark-mode-text fs-5 box-sub-service' dangerouslySetInnerHTML={{ __html: TranslationsService.labels('services')[area_id].items[sub_area][service_id].desc }}></p>
                  </>
                )
                :
                (
                  <>
                    <p className='dark-mode-text m-0 breadcrumb-detail'>
                      <Link to='/' className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
                      &nbsp;&#9656;&nbsp;
                      <Link to='/services' className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.services.label`)}</Link>
                      &nbsp;&#9656;&nbsp;
                      <Link to={`/services/${area_id}`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`services.${area_id}.title`)}</Link>
                    </p>
                    <h2 className='syd-title light fw-bold'>{TranslationsService.labels(`services.${area_id}.${service_id}.title`)}</h2>
                    <p className='pre-line-w-space dark-mode-text fs-5 box-sub-service' dangerouslySetInnerHTML={{ __html: TranslationsService.labels(`services.${area_id}.${service_id}.desc`) }}></p>
                  </>
                )
              }
            </div>
          </header>
        )
        :
        (
        <header className='p-3 syd-bg-dark header-services-detail area-service d-flex align-items-center'>
          <div>
            <p className='dark-mode-text m-0 breadcrumb-detail'>
              <Link to='/' className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
              &nbsp;&#9656;&nbsp;
              <Link to='/services' className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.services.label`)}</Link>
            </p>
            <h2 className='syd-title light fw-bold'>{TranslationsService.labels(`services.${area_id}.title`)}</h2>
            <p className='pre-line-w-space dark-mode-text fs-5' dangerouslySetInnerHTML={{ __html: TranslationsService.labels(`services.${area_id}.desc`) }}></p>
          </div>
        </header>
        )
      }
      
      <div className='container-fluid p-0'>
      {
        service_id ?
        (
          <div>
            {
              sub_area ?
              (
                <div>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TranslationsService.labels('services')[area_id].items[sub_area][service_id].text) }} className='dark-mode-text fs-5 box-desc-serv'></div>
                  {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text_test1) }} className='dark-mode-text fs-5 box-desc-serv'></div> */}
                  {
                    TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.contact-text`) && TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.contact-mail`) &&
                    <div className='box-more-info-service p-5 mb-5 w-max-content'>
                      <h4 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.contact-text`)) }} className='text-more-info'></h4>
                      <button className='btn-more-info-service syd-button m-0' onClick={openMailForContact}>
                        {TranslationsService.labels(`services.${area_id}.items.${sub_area}.${service_id}.contact-button-text`)}
                      </button>
                    </div>
                  }
                </div>
              )
              :
              (
                <div>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TranslationsService.labels(`services.${area_id}.${service_id}.text`)) }} className='dark-mode-text fs-5 box-desc-serv'></div>
                  {
                    TranslationsService.labels(`services.${area_id}.${service_id}.contact-text`) && TranslationsService.labels(`services.${area_id}.${service_id}.contact-mail`) &&
                    <div className='box-more-info-service p-5 mb-5 w-max-content'>
                      <h4 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TranslationsService.labels(`services.${area_id}.${service_id}.contact-text`)) }} className='text-more-info'></h4>
                      <button className='btn-more-info-service syd-button m-0' onClick={openMailForContact}>
                        {TranslationsService.labels(`services.${area_id}.${service_id}.contact-button-text`)}
                      </button>
                    </div>
                  }
                </div>
              )
            }
          </div>
        )
        :
        (
          <div className='row p-2 row-gap-3'>
            {
              TranslationsService.labels('services')[area_id].items ?
              (
                Object.keys(TranslationsService.labels('services')[area_id].items).map((_sub, i) => (
                  <div key={i}>
                    <Link to={`/services/${area_id}/${_sub}`} className='text-deco-none d-flex gap-3 align-items-center title-area pb-3'>
                      <h4 className='dark-mode-text m-0 fw-bold transition-03s-eio fs-3'>{TranslationsService.labels('services')[area_id].items[_sub].title}</h4>
                    </Link>
                    <div className='row row-gap-3'>
                      {
                        TranslationsService.labels('services')[area_id].items[_sub] &&
                        Object.keys(TranslationsService.labels('services')[area_id].items[_sub]).map((_subItem, j) => (
                          typeof TranslationsService.labels('services')[area_id].items[_sub][_subItem] === 'object' &&
                          TranslationsService.labels('services')[area_id].items[_sub][_subItem].title &&
                          (
                            <div className='col-sm-6 col-lg-4' key={j}>
                              <Link to={`/services/${area_id}/${_sub}/${_subItem}`} className='text-deco-none'>
                                <div className='syd-box small'>
                                  <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                      <h4 className='syd-title small light'>{TranslationsService.labels('services')[area_id].items[_sub][_subItem].title}</h4>
                                    </div>
                                    <div>
                                      <svg viewBox="0 0 10 11.55" className='box-arrow-item'>
                                        <polygon className="arrow-item" points="10 5.77 0 0 0 11.55 10 5.77"/>
                                      </svg>
                                    </div>
                                  </div>
                                  <p className='syd-paragraph' dangerouslySetInnerHTML={{ __html: TranslationsService.labels('services')[area_id].items[_sub][_subItem].desc }}></p>
                                </div>
                              </Link>
                            </div>
                          )
                        ))
                      }
                    </div>
                  </div>
                ))
              )
              :
              (
                Object.keys(TranslationsService.labels(`services.${area_id}`)).map((_sub, i) => (
                  TranslationsService.labels(`services.${area_id}.${_sub}.title`) && 
                  <div className='col-sm-6 col-lg-4' key={i}>
                    <Link to={`/services/${area_id}/${_sub}`} className='text-deco-none'>
                      <div className='syd-box small'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <div>
                            <h4 className='syd-title small light'>{TranslationsService.labels(`services.${area_id}.${_sub}.title`)}</h4>
                          </div>
                          <div>
                            <svg id="Livello_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11.55" className='box-arrow-item'>
                              <polygon className="arrow-item" points="10 5.77 0 0 0 11.55 10 5.77"/>
                            </svg>
                          </div>
                        </div>
                        <p className='syd-paragraph' dangerouslySetInnerHTML={{ __html: TranslationsService.labels(`services.${area_id}.${_sub}.desc`) }}></p>
                      </div>
                    </Link>
                  </div>
                ))
              )
            }
          </div>
        )
      }
      </div>


        {
        listClientStories?.length > 0 &&
        <div className='p-3'>
          <h2 className='dark-mode-title fw-bold'>{TranslationsService.labels('client_stories')}</h2>
          <div className='row gap-3 gap-lg-0'>
          {
          listClientStories.map((_cStory, ind) =>(
            <div className='col-sm-12 col-lg-4' key={ind}>
              <Link to='/insights/client-stories/dropsa' className='text-deco-none tile-client-story'>
                <div className='syd-box small flat d-flex position-relative cards-cl-sto'>
                  <div className='bg-client-stories' style={{backgroundImage:`url(https://d3t3s6w5yvhc3g.cloudfront.net/images/${_cStory.image})`}}></div>
                  <div className='body-stories-sect d-flex flex-column h-100 w-100'>
                    <h4 className="syd-title light">{_cStory.title}</h4>
                    <p className='syd-paragraph fs-5 pt-2'>{_cStory.description}</p>
                    <div className='row pt-5 mt-auto'>
                      <h5 className='dark-mode-text m-0 fs-6 d-flex flex-column flex-lg-row justify-content-between w-100'>
                        <span>{TranslationsService.labels(`services.${_cStory.service.split(',')[0]}.title`)} - {TranslationsService.labels(`services.${_cStory.service.split(',')[0]}.${_cStory.service.split(',')[1]}.title`)}</span>
                        <span className='text-end'>{TranslationsService.labels(`industries.${_cStory.industries}.title`)}</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            ))
          }
          </div>
        </div>
      }

    </div>
  );
};